import { ethers } from 'ethers';
import chainList from '../config/chainList';

export const getProvider = (chainId:number) => {
  const networkConfigs = Object.fromEntries(
    chainList.map((chain) => [chain.chainId, chain.rpcUrl]),
  );
  return new ethers.JsonRpcProvider(networkConfigs[chainId]);
};